module.exports = __webpack_public_path__ + "static/media/20.788688e9.mp4";